<template>
    <div class="container py-5 h-100">
        <div class="row d-flex justify-content-center align-items-center h-100">
            <div class="col-xl-10">
                <div class="card rounded-3 text-black">
                    <div class="row g-0">
                        <div class="col-lg-6">
                            <div class="card-body p-md-5 mx-md-4">
                                <div class="text-center">
                                    <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/lotus.webp"
                                        style="width: 185px;" alt="logo">
                                    <h4 class="mt-1 mb-5 pb-1">Ticketing 24</h4>
                                </div>
                                <!-- ERROR MESSAGE BLOCK -->
                                <div class="row g-0">
                                        <div v-if="statusCode && statusCode != 200" class="alert alert-danger" role="alert">
                                            <h5><strong v-html="errorMessage.title"></strong></h5>
                                            <p v-html="errorMessage.message"></p> 
                                        </div>
                                    </div>
                                <form>
                                    <slot name="form"></slot>
                                </form>
                            </div>
                        </div>
                        <div class="col-lg-6 d-flex align-items-center  login-theme-color">
                            <div class="text-white px-3 py-4 p-md-5 mx-md-4">
                                <h4 class="mb-4">{{ titlePage }}</h4>
                                <p class="small mb-0">{{ descriptionPage }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <dots-component v-if="isLoading"></dots-component>
</template>

<script setup>
import { toRefs, defineProps } from 'vue';
import dotsComponent from '@/components/loaders/dotsComponent.vue';

const props  = defineProps(
    {
        errorMessage:{type: Object, required: false, default: () => {title = "", message = ""}},
        titlePage: {type: String, required: false, default: () => ""},
        descriptionPage:{type:String, required: false, default: () => ""},
        statusCode: {type: Number, required: false, default: () => null},
        isLoading: {type: Boolean, required: false, default:() => false}
    }
);

toRefs(props);

</script>